(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDevicesTypesDialogController', TabDevicesTypesDialogController);

    TabDevicesTypesDialogController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'TabDevicesTypes', 'TabDevices', '$state'];

    function TabDevicesTypesDialogController ($timeout, $scope, $stateParams, entity, TabDevicesTypes, TabDevices, $state) {
        var vm = this;
        vm.tabDevicesTypes = entity;
        vm.tabdevices = TabDevices.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabDevicesTypesUpdate', result);
            vm.isSaving = false;
            $state.go('tab-devices-types');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tabDevicesTypes.id !== null) {
                TabDevicesTypes.update(vm.tabDevicesTypes, onSaveSuccess, onSaveError);
            } else {
                TabDevicesTypes.save(vm.tabDevicesTypes, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $state.go('tab-devices-types');
        };
    }
})();
